import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'currencyITFormat',
  standalone: true,
})
export class CurrencyITFormatPipe implements PipeTransform {
  // Inject CurrencyPipe into the constructor
  constructor(private currencyPipe: CurrencyPipe) {}

  transform(value: number | null | undefined | string, currencyCode: string = 'EUR', symbolDisplay: string = '€', digitsInfo: string = '1.0-2'): string | null {

    // Your custom logic
    if (value) {
      // Using CurrencyPipe to format the value
      return this.currencyPipe.transform(value, currencyCode, symbolDisplay, digitsInfo).replace(/,/g, '.');
    } else {
      return '';
    }
  }
}
